import SubHeaders from '@/components/Headers/SubHeaders'
import AddIcons from '@/icons/AddIcons'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Active from './Active'

const List = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('add_promo'),
                        onClick() {
                            navigate(paths.promoCreate)
                        },
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.promosList,
                        title: t('promo_manager'),
                    },
                ]}
            />
            <Active />
        </div>
    )
}

export default List
